<template>
  <div class="app-footer">
    <span>{{ isAgent ? this.$t('System.Agency') : this.$t('System.Dealer') }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  computed: {
    ...mapGetters([
      'isAgent'
    ])
  }
}
</script>

<style>

</style>
